var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40C44.4183 0 48 3.58172 48 8V48L0 0Z",
    fill: "#2DB55D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6666 14.0041V13.3141C40.6666 12.8538 41.0396 12.4807 41.4999 12.4807C41.9601 12.4807 42.3332 12.8538 42.3332 13.3141V14.0045C42.3311 17.6951 39.9018 20.9447 36.3627 21.9911C32.8236 23.0375 29.0177 21.6315 27.009 18.5354C25.0003 15.4394 25.2673 11.3909 27.6651 8.58544C30.063 5.77997 34.0205 4.88582 37.3916 6.38788C37.8119 6.57519 38.0009 7.06784 37.8136 7.48823C37.6263 7.90863 37.1336 8.09757 36.7132 7.91026C34.0164 6.70861 30.8503 7.42393 28.9321 9.66831C27.0138 11.9127 26.8002 15.1515 28.4072 17.6283C30.0141 20.1051 33.0588 21.23 35.8901 20.3929C38.7214 19.5557 40.6649 16.956 40.6666 14.0041ZM31.1606 13.0431C31.486 12.7177 32.0137 12.7177 32.3391 13.0431L33.9996 14.7036L40.9103 7.78593C41.2356 7.46033 41.7632 7.46006 42.0888 7.78534C42.4144 8.11061 42.4147 8.63825 42.0894 8.96385L34.5894 16.4713C34.264 16.7971 33.7362 16.7972 33.4106 16.4716L31.1606 14.2216C30.8352 13.8962 30.8352 13.3686 31.1606 13.0431Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckImage);
export default __webpack_public_path__ + "static/media/check-image.8f1f9c8f437f63c09038a37c71e2e658.svg";
export { ForwardRef as ReactComponent };